
/* API */
import { adminOperators } from "../api/Operator"
import { getAdmin } from "../api/Admin"

/* JWT */
import { isExpired } from "react-jwt"


export const actionOperator = (store) => {

    const token = localStorage.getItem("token")

    const stopLoading = () => store.dispatch({ type: "SET_LOADING", payload: false })

    /* Нет токена или протух → снимаем загрузку, чтобы не висел спиннер */
    if (!token || isExpired(token)) {
        localStorage.removeItem("token")
        stopLoading()
        return
    }

    adminOperators(token).then((response) => {
        if (response && response.status === 200) {
            const list = response.data.map((operator) => ({ ...operator, checked: true }))
            store.dispatch({
                type: "SET_OPERATORS",
                payload: list,
            })
        }
    }).catch(() => {
        /* сеть упала — всё равно снимем загрузку ниже */
    }).finally(() => {
        stopLoading()
    })
}

export const getAdminVariables = (store) => {

    const token = localStorage.getItem("token")

    if (token && !isExpired(token)) {
        getAdmin(token).then((response) => {
            if (response.status === 200) {
                const data = response.data
                store.dispatch({
                    type: "SET_ADMIN",
                    payload: data,
                })
            }
            else if (response.status === 498) {
                localStorage.removeItem("token")
            }
        })
    }
    else {
        localStorage.removeItem("token")
    }
}